// Generated with util/create-component.js
import React, { useContext, useEffect } from 'react'
import ReactDOM from 'react-dom'
import { PortalProps } from './Portal.types'

import { ThemeContext } from '../Themer/Themer'

const Portal: React.FC<PortalProps> = ({ style = {}, onUnmount, container, children }) => {
    // if (!container) return null
    const node = container || document.getElementById('arctradeRelayApp')
    const themeContext = useContext(ThemeContext)
    let theme = themeContext.theme || { mode: 'LIGHT' }

    if (!node) {
        throw Error('Portal could not find a node for: ' + node)
    }

    useEffect(() => {
        return () => {
            if (onUnmount) {
                onUnmount()
            }
        }
    }, [])

    return ReactDOM.createPortal(
        <div data-testid='Portal' style={style} className={`r-relay-container r-portal r-theme-${theme.mode}`}>
            <div>{children}</div>
        </div>,
        node,
    )
}

export default Portal
